import App from './container';

export default App;



// WEBPACK FOOTER //
// ./src/routes/App/index.js